import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { SmsTemplateService } from '../../../../../../definition/sms-template/services/sms-template.service';
import { AppMessageService } from '../../../../../../../shared/services/app-message/app-message.service';
import { combineLatest, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectAppointmentInfos, selectCaseUid,selectMainVehicleLog } from '../../../../../store/selectors/common-case.selector';
import { DateFormatPipe } from '../../../../../../../shared/pipes/date.pipe';
import { CaseService } from '../../../../../services/case.services';
import { environment } from '../../../../../../../../environments/environment';

export interface SmsTemplate {
  id: number;
  name: string;
  content: string;
  toPhoneNumbers?: string[];
}

@Component({
  selector: 'app-case-send-sms',
  templateUrl: './case-send-sms.component.html',
  styleUrl: './case-send-sms.component.scss',
})
export class CaseSendSmsComponent implements OnInit, OnDestroy {
  constructor(
    private readonly smsTemplateService: SmsTemplateService,
    private readonly messageService: AppMessageService,
    private readonly store: Store,
    private readonly datePipe: DateFormatPipe,
    private readonly caseService: CaseService
  ) {}

  showPopup: boolean = false;
  smsTemplates: SmsTemplate[] = [];
  filteredTemplates: SmsTemplate[] = [];

  selectedTemplate: SmsTemplate | null = null;
  availablePhones: string[] = [];
  patientPhones: string[] = [];
  selectedPhones: string[] = [];
  selectedContent = '';
  uid:string|null=null;
  private subscription!: Subscription;

  dataMap = {
    'Randevu Tarihi': '',
    'Randevu Saati': '',
    'Hasta Konum Linki': '',
    'Plaka': '',
    'Ambulans Konum Linki':'',
    'Belge Yükleme Linki':''
  };

  ngOnInit(): void {
     this.smsTemplateService.getAllFilter({}, {
      'filter.isActive': true,
      'filter.getAll':true

     }).subscribe({
       next: (res) => {
         this.smsTemplates = res?.items ?? [];
         // örnek tanım this.smsTemplates[0].toPhoneNumbers=['538 946 62 00','538 946 62 50']
         this.smsTemplates = this.smsTemplates.map((template) => {
          const normalizedPhones = Array.isArray(template.toPhoneNumbers)
            ? template.toPhoneNumbers.map((p) => (p ? p.replaceAll(/\s+/g, '') : ''))
            : [];
          return {
            ...template,
            toPhoneNumbers: normalizedPhones,
          };
        });
       }
    });

    this.subscription = combineLatest([
      this.store.select(selectAppointmentInfos),
      this.store.select(selectCaseUid),
      this.store.select(selectMainVehicleLog)
    ]).subscribe({
      next: ([appointmentInfos,uid,mainVehicleLog]) => {
        this.uid=uid
        this.dataMap = {
          ...this.dataMap,
          'Randevu Tarihi': appointmentInfos.appointmentStartDate
            ? this.datePipe.transform(
                new Date(appointmentInfos.appointmentStartDate)
              )
            : '[Randevu Tarihi]',
          'Randevu Saati': appointmentInfos.appointmentStartDate
            ? this.datePipe
                .transform(
                  new Date(appointmentInfos.appointmentStartDate),
                  true
                )
                .split(' ')[1] ?? '[Randevu Saati]'
            : '[Randevu Saati]',

            'Hasta Konum Linki': uid ? `${environment.citizenMobileUrl}mobile/location-sharing/${uid}`
            : '[Hasta Konum Linki]',
            'Belge Yükleme Linki': uid ? `${environment.citizenMobileUrl}mobile/document-sharing/${uid}`
            : '[Belge Yükleme Linki]',
           'Plaka':mainVehicleLog ? mainVehicleLog.vehiclePlate : '[Plaka]',
           'Ambulans Konum Linki':uid ? `${environment.citizenMobileUrl}mobile/ambulance-location-sharing/${uid}` : '[Ambulans Konum Linki]'
        };
      },
    });
  }

  onTemplateChange(event: Event) {
    this.selectedPhones = [];
    if (this.selectedTemplate) {
      this.availablePhones = [
        ...(this.selectedTemplate.toPhoneNumbers || []),
        ...this.patientPhones,
      ];

      this.selectedContent = this.selectedTemplate.content;
      for (const [key, value] of Object.entries(this.dataMap)) {
        this.selectedContent = this.selectedContent.replaceAll(`[${key}]`, value);
      }
    } else {
      this.availablePhones = [];
      this.selectedPhones = [];
    }
  }

  initilize(phones: any[],caseTypeId:number|null, recordType?:string|null) {
    this.showPopup = true;
    //this.filteredTemplates=this.smsTemplates?.filter((t:any)=>t?.caseTypeId?.some((c:any)=>c?.incrementId===caseTypeId)) ?? []
    this.filteredTemplates = this.smsTemplates?.filter((t: any) => {
      const hasCaseType = t?.caseTypeId?.some((c: any) => c?.id === caseTypeId);
      const hasRecordType = t?.recordTypes?.includes(recordType);

      return hasCaseType && hasRecordType;
    }) ?? [];


    this.patientPhones = phones.map((p) => p.replace('+90', ''));
  }

  isPhoneSelected(phone: string): boolean {
    return this.selectedPhones.includes(phone);
  }

  togglePhone(phone: string) {
    const isSelected = this.isPhoneSelected(phone);
    if (isSelected) {
      this.selectedPhones = this.selectedPhones.filter(p => p !== phone);
    } else {
      this.selectedPhones = [...this.selectedPhones, phone];
    }

    if (this.selectedPhones.length) {
      const lastIndex = this.selectedPhones.length - 1;
      this.selectedPhones[lastIndex] = this.selectedPhones[lastIndex].replaceAll(/\s+/g, '');
    }
  }

  sendSms() {
    if (this.selectedPhones.length === 0) {
      this.messageService.warningToast(
        '',
        'Lütfen en az bir telefon numarası seçiniz.'
      );
      return;
    }
    if (!this.selectedContent || !this.selectedTemplate) {
      return;
    }

    this.caseService
      .sendSms(this.selectedContent, this.selectedPhones,{templateId:this.selectedTemplate.id,uid:this.uid})
      .subscribe((res) => {
        this.showPopup = false;
        this.messageService.successToast(
          '',
          'SMS gönderildi.'
        );
      });
  }

  handleChipAdd(event: any) {
    const phone = event.value.replaceAll(/\s+/g, ''); // tüm boşlukları sil
    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone)) {
      this.selectedPhones = this.selectedPhones.filter((p) => p !== phone);
    }
    if (this.selectedPhones.length > 0) {
      const lastIndex = this.selectedPhones.length - 1;
      this.selectedPhones[lastIndex] = this.selectedPhones.at(lastIndex)?.replaceAll(/\s+/g, '') ?? '';
    }
  }

  clearAll() {
    this.selectedTemplate = null;
    this.selectedTemplate = null;
    this.selectedContent = '';
    this.availablePhones = [];
    this.patientPhones = [];
    this.selectedPhones = [];
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event): void {
    this.unSub();
  }

  unSub() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.unSub();
  }
}
